import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, Paper } from "@material-ui/core";
import BasicFilters from "./BasicFilters";
import ExtendedFilters from "./ExtendedFilters";
import clientPageStyle from "features/client/styles";

const useStyles = makeStyles(clientPageStyle);

function FiltersWithoutTaxNumber({ filterLens, onReset, onSearch, loading }) {
  const classes = useStyles();
  const [extended, setExtended] = useState(false);

  const handleSearch = useCallback(() => onSearch(extended), [extended, onSearch]);

  const handleKeypress = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        handleSearch();
      }
    },
    [handleSearch]
  );

  return (
    <Paper className={classes.filterStyle} onKeyUp={handleKeypress}>
      {extended ? (
        <ExtendedFilters
          setExtended={setExtended}
          filterLens={filterLens}
          onReset={onReset}
          onSearch={handleSearch}
          loading={loading}
        />
      ) : (
        <BasicFilters
          setExtended={setExtended}
          filterLens={filterLens}
          onReset={onReset}
          onSearch={handleSearch}
          loading={loading}
        />
      )}
    </Paper>
  );
}

FiltersWithoutTaxNumber.propTypes = {
  filterLens: PropTypes.object.isRequired,
  onReset: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default FiltersWithoutTaxNumber;
